import * as actions_analytics from 'actions/analytics-actions';
import * as toolbox from 'components/common/toolbox';
import React, { useEffect } from 'react';
import { Ibox } from 'enspire-manager-framework';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';

export default function InvoicesCard({ startdate, enddate }) {

    const params = useParams();
    const dispatch = useDispatch();

    const analytics = useSelector((store) => store.analytics);
    const invoices = analytics?.analytics_invoices;
    
    useEffect(() => {
        if (startdate && enddate) {
            dispatch(actions_analytics.getInvoiceAnalytics(params.handle, params.appId, startdate, enddate));
        }
    }, [startdate, enddate, params.handle]);

    return (
        <div className="ibox animated fadeInRight animation-delay-4">
            <Ibox
                className=""
                title={ <h1 className="main-heading heading-invoice dashboard align-self-start mx-2">Invoices</h1> }
                // tools={<span className="badge badge-success float-right">Today</span>}
            >
                <div className="px-2">
                    <h1 className="no-margins">{toolbox.formatNumber(invoices?.totalInvoiced ?? 0, 2, true)}</h1>
                    <small>Total Invoices</small>

                    <hr />

                    <div className="row">
                        <div className="col-4">
                            <small className="stats-label">#&nbsp;Invoices</small>
                            <h4>{ invoices.count }</h4>
                        </div>
                        <div className="col-4">
                            <small className="stats-label">Un-Paid</small>
                            <h4>{ invoices.count - invoices.paid }</h4>
                        </div>
                        <div className="col-4 text-right">
                            <small className="stats-label">$&nbsp;Paid</small>
                            <h4>{ toolbox.formatNumber(invoices?.totalPaid ?? 0, 2, true) }</h4>
                        </div>
                    </div>
                    
                </div>
            </Ibox>
        </div>
    );
}